module.exports = __webpack_public_path__ + "static/media/logo.59c701a5.svg";